// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_comp_kpi_cfg.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  FstmtRef,
  FstmtRefAgg,
  MethodologyEnum,
  methodologyEnumFromJSON,
  methodologyEnumToJSON,
  PlanItemPosManualDecInput,
  StcsCalcItemStatus,
  StcsFpnaPeriod,
} from "./stcs_comp_plan_cfg.entity";
import {
  KpiPosActivationModeEnum,
  kpiPosActivationModeEnumFromJSON,
  kpiPosActivationModeEnumToJSON,
  StcsDisplayValueTypeEnum,
  stcsDisplayValueTypeEnumFromJSON,
  stcsDisplayValueTypeEnumToJSON,
  StcsFpnaTypeEnum,
  stcsFpnaTypeEnumFromJSON,
  stcsFpnaTypeEnumToJSON,
  StcsKpiEnum,
  stcsKpiEnumFromJSON,
  stcsKpiEnumToJSON,
} from "./stcs_enums.entity";

export const protobufPackage = "stcs_cmw";

export interface StcsCompKpiCfg {
  /** Unique identifier for the plan configuration */
  id: string;
  /** Version string for the plan configuration */
  version: string;
  /** Metadata about the plan (creator, org, dates, etc.) */
  meta: StcsCompKpiCfgMetaData | undefined;
  custom_map: { [key: string]: StcsCompKpiCfgItem };
  growth_map: { [key: string]: StcsCompKpiCfgItem };
  margin_map: { [key: string]: StcsCompKpiCfgItem };
  nwc_map: { [key: string]: StcsCompKpiCfgItem };
  debt_map: { [key: string]: StcsCompKpiCfgItem };
  return_map: { [key: string]: StcsCompKpiCfgItem };
  cf_map: { [key: string]: StcsCompKpiCfgItem };
}

export interface StcsCompKpiCfg_CustomMapEntry {
  key: string;
  value: StcsCompKpiCfgItem | undefined;
}

export interface StcsCompKpiCfg_GrowthMapEntry {
  key: string;
  value: StcsCompKpiCfgItem | undefined;
}

export interface StcsCompKpiCfg_MarginMapEntry {
  key: string;
  value: StcsCompKpiCfgItem | undefined;
}

export interface StcsCompKpiCfg_NwcMapEntry {
  key: string;
  value: StcsCompKpiCfgItem | undefined;
}

export interface StcsCompKpiCfg_DebtMapEntry {
  key: string;
  value: StcsCompKpiCfgItem | undefined;
}

export interface StcsCompKpiCfg_ReturnMapEntry {
  key: string;
  value: StcsCompKpiCfgItem | undefined;
}

export interface StcsCompKpiCfg_CfMapEntry {
  key: string;
  value: StcsCompKpiCfgItem | undefined;
}

/** Metadata for a compensation plan configuration */
export interface StcsCompKpiCfgMetaData {
  /** User who created the plan */
  ref_id_user: string;
  /** Organization ID */
  ref_id_org: string;
  /** Company ID */
  ref_id_comp: string;
  /** Creation timestamp (UTC, ISO format) */
  obj_created_iso_utc: string;
  /** Last update timestamp (UTC, ISO format) */
  obj_updated_iso_utc: string;
  /** True if this is a draft plan */
  is_draft: boolean;
}

/** 1:1 StcsCompKpiCfgItem to one row in UI */
export interface StcsCompKpiCfgItem {
  /** FPNA type for this KPI item */
  fpna_type: StcsFpnaTypeEnum;
  /** Sort index for ordering in UI */
  sort_index: number;
  /** Display value type for UI representation, not 1:1 related to logic type */
  display_value_type: StcsDisplayValueTypeEnum;
  /** Position map: key is position ID, value is PlanPosItem */
  kpi_pos_map: { [key: string]: KpiPosItem };
  /** KPI Last Actuals Result Values Map */
  kpi_actuals_rv_map: { [key: string]: number };
  /** KPI Plan Result Values Map */
  kpi_plan_rv_map: { [key: string]: number };
  /** True if this is a structural item (not a data row) */
  is_struct_item: boolean;
}

export interface StcsCompKpiCfgItem_KpiPosMapEntry {
  key: string;
  value: KpiPosItem | undefined;
}

export interface StcsCompKpiCfgItem_KpiActualsRvMapEntry {
  key: string;
  value: number;
}

export interface StcsCompKpiCfgItem_KpiPlanRvMapEntry {
  key: string;
  value: number;
}

/** Represents a single plan position (main position) */
export interface KpiPosItem {
  pos_logic_type: MethodologyEnum;
  /** Index of this position in the plan */
  pos_index: number;
  /** True if this is a structural position */
  is_struct_item: boolean;
  /** Display value type for UI representation, not 1:1 related to logic type */
  display_value_type: StcsDisplayValueTypeEnum;
  /** When this position activates: actuals-only, plan-only, or both */
  pos_activation_mode?:
    | KpiPosActivationModeEnum
    | undefined;
  /** Manual decimal input strategy */
  manual_dec_input?:
    | PlanItemPosManualDecInput
    | undefined;
  /** Formula-based calculation strategy */
  formula_based?: KpiItemPosFormulaBased | undefined;
}

export interface KpiItemPosFormulaBased {
  /** Status object for this position (code, message, overrides) */
  status: StcsCalcItemStatus | undefined;
  pos_input_base_amount: number;
  formula_based_input_list: KpiFormulaBasedInput[];
  pos_actuals_rv_map: { [key: string]: number };
  pos_plan_rv_map: { [key: string]: number };
}

export interface KpiItemPosFormulaBased_PosActualsRvMapEntry {
  key: string;
  value: number;
}

export interface KpiItemPosFormulaBased_PosPlanRvMapEntry {
  key: string;
  value: number;
}

export interface KpiFormulaBasedInput {
  /** e.g., "+", "-", "*", "/" */
  math_op?:
    | string
    | undefined;
  /** Reference to a financial statement item */
  ref_fstmt?:
    | FstmtRef
    | undefined;
  /** Reference to another KPI item */
  kpi_ref_item?:
    | KpiFormulaBasedInput_KpiRefItem
    | undefined;
  /** Reference to a financial statement item for aggregation e.g. SUM all level 1 items */
  ref_fstmt_agg?: FstmtRefAgg | undefined;
}

export interface KpiFormulaBasedInput_KpiRefItem {
  kpi_type: StcsKpiEnum;
  ref_id_kpi: string;
  offset_in_months: number;
  fpna_period?: StcsFpnaPeriod | undefined;
}

function createBaseStcsCompKpiCfg(): StcsCompKpiCfg {
  return {
    id: "",
    version: "",
    meta: undefined,
    custom_map: {},
    growth_map: {},
    margin_map: {},
    nwc_map: {},
    debt_map: {},
    return_map: {},
    cf_map: {},
  };
}

export const StcsCompKpiCfg: MessageFns<StcsCompKpiCfg> = {
  encode(message: StcsCompKpiCfg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsCompKpiCfgMetaData.encode(message.meta, writer.uint32(26).fork()).join();
    }
    Object.entries(message.custom_map).forEach(([key, value]) => {
      StcsCompKpiCfg_CustomMapEntry.encode({ key: key as any, value }, writer.uint32(162).fork()).join();
    });
    Object.entries(message.growth_map).forEach(([key, value]) => {
      StcsCompKpiCfg_GrowthMapEntry.encode({ key: key as any, value }, writer.uint32(170).fork()).join();
    });
    Object.entries(message.margin_map).forEach(([key, value]) => {
      StcsCompKpiCfg_MarginMapEntry.encode({ key: key as any, value }, writer.uint32(178).fork()).join();
    });
    Object.entries(message.nwc_map).forEach(([key, value]) => {
      StcsCompKpiCfg_NwcMapEntry.encode({ key: key as any, value }, writer.uint32(186).fork()).join();
    });
    Object.entries(message.debt_map).forEach(([key, value]) => {
      StcsCompKpiCfg_DebtMapEntry.encode({ key: key as any, value }, writer.uint32(194).fork()).join();
    });
    Object.entries(message.return_map).forEach(([key, value]) => {
      StcsCompKpiCfg_ReturnMapEntry.encode({ key: key as any, value }, writer.uint32(202).fork()).join();
    });
    Object.entries(message.cf_map).forEach(([key, value]) => {
      StcsCompKpiCfg_CfMapEntry.encode({ key: key as any, value }, writer.uint32(210).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiCfg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiCfg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsCompKpiCfgMetaData.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          const entry20 = StcsCompKpiCfg_CustomMapEntry.decode(reader, reader.uint32());
          if (entry20.value !== undefined) {
            message.custom_map[entry20.key] = entry20.value;
          }
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          const entry21 = StcsCompKpiCfg_GrowthMapEntry.decode(reader, reader.uint32());
          if (entry21.value !== undefined) {
            message.growth_map[entry21.key] = entry21.value;
          }
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          const entry22 = StcsCompKpiCfg_MarginMapEntry.decode(reader, reader.uint32());
          if (entry22.value !== undefined) {
            message.margin_map[entry22.key] = entry22.value;
          }
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          const entry23 = StcsCompKpiCfg_NwcMapEntry.decode(reader, reader.uint32());
          if (entry23.value !== undefined) {
            message.nwc_map[entry23.key] = entry23.value;
          }
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          const entry24 = StcsCompKpiCfg_DebtMapEntry.decode(reader, reader.uint32());
          if (entry24.value !== undefined) {
            message.debt_map[entry24.key] = entry24.value;
          }
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          const entry25 = StcsCompKpiCfg_ReturnMapEntry.decode(reader, reader.uint32());
          if (entry25.value !== undefined) {
            message.return_map[entry25.key] = entry25.value;
          }
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          const entry26 = StcsCompKpiCfg_CfMapEntry.decode(reader, reader.uint32());
          if (entry26.value !== undefined) {
            message.cf_map[entry26.key] = entry26.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiCfg {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsCompKpiCfgMetaData.fromJSON(object.meta) : undefined,
      custom_map: isObject(object.custom_map)
        ? Object.entries(object.custom_map).reduce<{ [key: string]: StcsCompKpiCfgItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiCfgItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      growth_map: isObject(object.growth_map)
        ? Object.entries(object.growth_map).reduce<{ [key: string]: StcsCompKpiCfgItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiCfgItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      margin_map: isObject(object.margin_map)
        ? Object.entries(object.margin_map).reduce<{ [key: string]: StcsCompKpiCfgItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiCfgItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      nwc_map: isObject(object.nwc_map)
        ? Object.entries(object.nwc_map).reduce<{ [key: string]: StcsCompKpiCfgItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiCfgItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      debt_map: isObject(object.debt_map)
        ? Object.entries(object.debt_map).reduce<{ [key: string]: StcsCompKpiCfgItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiCfgItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      return_map: isObject(object.return_map)
        ? Object.entries(object.return_map).reduce<{ [key: string]: StcsCompKpiCfgItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiCfgItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      cf_map: isObject(object.cf_map)
        ? Object.entries(object.cf_map).reduce<{ [key: string]: StcsCompKpiCfgItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiCfgItem.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsCompKpiCfg): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsCompKpiCfgMetaData.toJSON(message.meta);
    }
    if (message.custom_map) {
      const entries = Object.entries(message.custom_map);
      if (entries.length > 0) {
        obj.custom_map = {};
        entries.forEach(([k, v]) => {
          obj.custom_map[k] = StcsCompKpiCfgItem.toJSON(v);
        });
      }
    }
    if (message.growth_map) {
      const entries = Object.entries(message.growth_map);
      if (entries.length > 0) {
        obj.growth_map = {};
        entries.forEach(([k, v]) => {
          obj.growth_map[k] = StcsCompKpiCfgItem.toJSON(v);
        });
      }
    }
    if (message.margin_map) {
      const entries = Object.entries(message.margin_map);
      if (entries.length > 0) {
        obj.margin_map = {};
        entries.forEach(([k, v]) => {
          obj.margin_map[k] = StcsCompKpiCfgItem.toJSON(v);
        });
      }
    }
    if (message.nwc_map) {
      const entries = Object.entries(message.nwc_map);
      if (entries.length > 0) {
        obj.nwc_map = {};
        entries.forEach(([k, v]) => {
          obj.nwc_map[k] = StcsCompKpiCfgItem.toJSON(v);
        });
      }
    }
    if (message.debt_map) {
      const entries = Object.entries(message.debt_map);
      if (entries.length > 0) {
        obj.debt_map = {};
        entries.forEach(([k, v]) => {
          obj.debt_map[k] = StcsCompKpiCfgItem.toJSON(v);
        });
      }
    }
    if (message.return_map) {
      const entries = Object.entries(message.return_map);
      if (entries.length > 0) {
        obj.return_map = {};
        entries.forEach(([k, v]) => {
          obj.return_map[k] = StcsCompKpiCfgItem.toJSON(v);
        });
      }
    }
    if (message.cf_map) {
      const entries = Object.entries(message.cf_map);
      if (entries.length > 0) {
        obj.cf_map = {};
        entries.forEach(([k, v]) => {
          obj.cf_map[k] = StcsCompKpiCfgItem.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiCfg>, I>>(base?: I): StcsCompKpiCfg {
    return StcsCompKpiCfg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiCfg>, I>>(object: I): StcsCompKpiCfg {
    const message = createBaseStcsCompKpiCfg();
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsCompKpiCfgMetaData.fromPartial(object.meta)
      : undefined;
    message.custom_map = Object.entries(object.custom_map ?? {}).reduce<{ [key: string]: StcsCompKpiCfgItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiCfgItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.growth_map = Object.entries(object.growth_map ?? {}).reduce<{ [key: string]: StcsCompKpiCfgItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiCfgItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.margin_map = Object.entries(object.margin_map ?? {}).reduce<{ [key: string]: StcsCompKpiCfgItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiCfgItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.nwc_map = Object.entries(object.nwc_map ?? {}).reduce<{ [key: string]: StcsCompKpiCfgItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiCfgItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.debt_map = Object.entries(object.debt_map ?? {}).reduce<{ [key: string]: StcsCompKpiCfgItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiCfgItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.return_map = Object.entries(object.return_map ?? {}).reduce<{ [key: string]: StcsCompKpiCfgItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiCfgItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.cf_map = Object.entries(object.cf_map ?? {}).reduce<{ [key: string]: StcsCompKpiCfgItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiCfgItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsCompKpiCfg_CustomMapEntry(): StcsCompKpiCfg_CustomMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiCfg_CustomMapEntry: MessageFns<StcsCompKpiCfg_CustomMapEntry> = {
  encode(message: StcsCompKpiCfg_CustomMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiCfgItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiCfg_CustomMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiCfg_CustomMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiCfgItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiCfg_CustomMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiCfgItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiCfg_CustomMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiCfgItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiCfg_CustomMapEntry>, I>>(base?: I): StcsCompKpiCfg_CustomMapEntry {
    return StcsCompKpiCfg_CustomMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiCfg_CustomMapEntry>, I>>(
    object: I,
  ): StcsCompKpiCfg_CustomMapEntry {
    const message = createBaseStcsCompKpiCfg_CustomMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiCfgItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiCfg_GrowthMapEntry(): StcsCompKpiCfg_GrowthMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiCfg_GrowthMapEntry: MessageFns<StcsCompKpiCfg_GrowthMapEntry> = {
  encode(message: StcsCompKpiCfg_GrowthMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiCfgItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiCfg_GrowthMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiCfg_GrowthMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiCfgItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiCfg_GrowthMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiCfgItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiCfg_GrowthMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiCfgItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiCfg_GrowthMapEntry>, I>>(base?: I): StcsCompKpiCfg_GrowthMapEntry {
    return StcsCompKpiCfg_GrowthMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiCfg_GrowthMapEntry>, I>>(
    object: I,
  ): StcsCompKpiCfg_GrowthMapEntry {
    const message = createBaseStcsCompKpiCfg_GrowthMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiCfgItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiCfg_MarginMapEntry(): StcsCompKpiCfg_MarginMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiCfg_MarginMapEntry: MessageFns<StcsCompKpiCfg_MarginMapEntry> = {
  encode(message: StcsCompKpiCfg_MarginMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiCfgItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiCfg_MarginMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiCfg_MarginMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiCfgItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiCfg_MarginMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiCfgItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiCfg_MarginMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiCfgItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiCfg_MarginMapEntry>, I>>(base?: I): StcsCompKpiCfg_MarginMapEntry {
    return StcsCompKpiCfg_MarginMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiCfg_MarginMapEntry>, I>>(
    object: I,
  ): StcsCompKpiCfg_MarginMapEntry {
    const message = createBaseStcsCompKpiCfg_MarginMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiCfgItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiCfg_NwcMapEntry(): StcsCompKpiCfg_NwcMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiCfg_NwcMapEntry: MessageFns<StcsCompKpiCfg_NwcMapEntry> = {
  encode(message: StcsCompKpiCfg_NwcMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiCfgItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiCfg_NwcMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiCfg_NwcMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiCfgItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiCfg_NwcMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiCfgItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiCfg_NwcMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiCfgItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiCfg_NwcMapEntry>, I>>(base?: I): StcsCompKpiCfg_NwcMapEntry {
    return StcsCompKpiCfg_NwcMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiCfg_NwcMapEntry>, I>>(object: I): StcsCompKpiCfg_NwcMapEntry {
    const message = createBaseStcsCompKpiCfg_NwcMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiCfgItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiCfg_DebtMapEntry(): StcsCompKpiCfg_DebtMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiCfg_DebtMapEntry: MessageFns<StcsCompKpiCfg_DebtMapEntry> = {
  encode(message: StcsCompKpiCfg_DebtMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiCfgItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiCfg_DebtMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiCfg_DebtMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiCfgItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiCfg_DebtMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiCfgItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiCfg_DebtMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiCfgItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiCfg_DebtMapEntry>, I>>(base?: I): StcsCompKpiCfg_DebtMapEntry {
    return StcsCompKpiCfg_DebtMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiCfg_DebtMapEntry>, I>>(object: I): StcsCompKpiCfg_DebtMapEntry {
    const message = createBaseStcsCompKpiCfg_DebtMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiCfgItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiCfg_ReturnMapEntry(): StcsCompKpiCfg_ReturnMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiCfg_ReturnMapEntry: MessageFns<StcsCompKpiCfg_ReturnMapEntry> = {
  encode(message: StcsCompKpiCfg_ReturnMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiCfgItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiCfg_ReturnMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiCfg_ReturnMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiCfgItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiCfg_ReturnMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiCfgItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiCfg_ReturnMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiCfgItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiCfg_ReturnMapEntry>, I>>(base?: I): StcsCompKpiCfg_ReturnMapEntry {
    return StcsCompKpiCfg_ReturnMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiCfg_ReturnMapEntry>, I>>(
    object: I,
  ): StcsCompKpiCfg_ReturnMapEntry {
    const message = createBaseStcsCompKpiCfg_ReturnMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiCfgItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiCfg_CfMapEntry(): StcsCompKpiCfg_CfMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiCfg_CfMapEntry: MessageFns<StcsCompKpiCfg_CfMapEntry> = {
  encode(message: StcsCompKpiCfg_CfMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiCfgItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiCfg_CfMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiCfg_CfMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiCfgItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiCfg_CfMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiCfgItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiCfg_CfMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiCfgItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiCfg_CfMapEntry>, I>>(base?: I): StcsCompKpiCfg_CfMapEntry {
    return StcsCompKpiCfg_CfMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiCfg_CfMapEntry>, I>>(object: I): StcsCompKpiCfg_CfMapEntry {
    const message = createBaseStcsCompKpiCfg_CfMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiCfgItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiCfgMetaData(): StcsCompKpiCfgMetaData {
  return {
    ref_id_user: "",
    ref_id_org: "",
    ref_id_comp: "",
    obj_created_iso_utc: "",
    obj_updated_iso_utc: "",
    is_draft: false,
  };
}

export const StcsCompKpiCfgMetaData: MessageFns<StcsCompKpiCfgMetaData> = {
  encode(message: StcsCompKpiCfgMetaData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(50).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(58).string(message.obj_updated_iso_utc);
    }
    if (message.is_draft !== false) {
      writer.uint32(64).bool(message.is_draft);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiCfgMetaData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiCfgMetaData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.is_draft = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiCfgMetaData {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
      is_draft: isSet(object.is_draft) ? globalThis.Boolean(object.is_draft) : false,
    };
  },

  toJSON(message: StcsCompKpiCfgMetaData): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    if (message.is_draft !== false) {
      obj.is_draft = message.is_draft;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiCfgMetaData>, I>>(base?: I): StcsCompKpiCfgMetaData {
    return StcsCompKpiCfgMetaData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiCfgMetaData>, I>>(object: I): StcsCompKpiCfgMetaData {
    const message = createBaseStcsCompKpiCfgMetaData();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    message.is_draft = object.is_draft ?? false;
    return message;
  },
};

function createBaseStcsCompKpiCfgItem(): StcsCompKpiCfgItem {
  return {
    fpna_type: 0,
    sort_index: 0,
    display_value_type: 0,
    kpi_pos_map: {},
    kpi_actuals_rv_map: {},
    kpi_plan_rv_map: {},
    is_struct_item: false,
  };
}

export const StcsCompKpiCfgItem: MessageFns<StcsCompKpiCfgItem> = {
  encode(message: StcsCompKpiCfgItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fpna_type !== 0) {
      writer.uint32(8).int32(message.fpna_type);
    }
    if (message.sort_index !== 0) {
      writer.uint32(16).uint32(message.sort_index);
    }
    if (message.display_value_type !== 0) {
      writer.uint32(40).int32(message.display_value_type);
    }
    Object.entries(message.kpi_pos_map).forEach(([key, value]) => {
      StcsCompKpiCfgItem_KpiPosMapEntry.encode({ key: key as any, value }, writer.uint32(58).fork()).join();
    });
    Object.entries(message.kpi_actuals_rv_map).forEach(([key, value]) => {
      StcsCompKpiCfgItem_KpiActualsRvMapEntry.encode({ key: key as any, value }, writer.uint32(66).fork()).join();
    });
    Object.entries(message.kpi_plan_rv_map).forEach(([key, value]) => {
      StcsCompKpiCfgItem_KpiPlanRvMapEntry.encode({ key: key as any, value }, writer.uint32(74).fork()).join();
    });
    if (message.is_struct_item !== false) {
      writer.uint32(96).bool(message.is_struct_item);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiCfgItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiCfgItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fpna_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.sort_index = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.display_value_type = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          const entry7 = StcsCompKpiCfgItem_KpiPosMapEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.kpi_pos_map[entry7.key] = entry7.value;
          }
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          const entry8 = StcsCompKpiCfgItem_KpiActualsRvMapEntry.decode(reader, reader.uint32());
          if (entry8.value !== undefined) {
            message.kpi_actuals_rv_map[entry8.key] = entry8.value;
          }
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          const entry9 = StcsCompKpiCfgItem_KpiPlanRvMapEntry.decode(reader, reader.uint32());
          if (entry9.value !== undefined) {
            message.kpi_plan_rv_map[entry9.key] = entry9.value;
          }
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.is_struct_item = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiCfgItem {
    return {
      fpna_type: isSet(object.fpna_type) ? stcsFpnaTypeEnumFromJSON(object.fpna_type) : 0,
      sort_index: isSet(object.sort_index) ? globalThis.Number(object.sort_index) : 0,
      display_value_type: isSet(object.display_value_type)
        ? stcsDisplayValueTypeEnumFromJSON(object.display_value_type)
        : 0,
      kpi_pos_map: isObject(object.kpi_pos_map)
        ? Object.entries(object.kpi_pos_map).reduce<{ [key: string]: KpiPosItem }>((acc, [key, value]) => {
          acc[key] = KpiPosItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      kpi_actuals_rv_map: isObject(object.kpi_actuals_rv_map)
        ? Object.entries(object.kpi_actuals_rv_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      kpi_plan_rv_map: isObject(object.kpi_plan_rv_map)
        ? Object.entries(object.kpi_plan_rv_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      is_struct_item: isSet(object.is_struct_item) ? globalThis.Boolean(object.is_struct_item) : false,
    };
  },

  toJSON(message: StcsCompKpiCfgItem): unknown {
    const obj: any = {};
    if (message.fpna_type !== 0) {
      obj.fpna_type = stcsFpnaTypeEnumToJSON(message.fpna_type);
    }
    if (message.sort_index !== 0) {
      obj.sort_index = Math.round(message.sort_index);
    }
    if (message.display_value_type !== 0) {
      obj.display_value_type = stcsDisplayValueTypeEnumToJSON(message.display_value_type);
    }
    if (message.kpi_pos_map) {
      const entries = Object.entries(message.kpi_pos_map);
      if (entries.length > 0) {
        obj.kpi_pos_map = {};
        entries.forEach(([k, v]) => {
          obj.kpi_pos_map[k] = KpiPosItem.toJSON(v);
        });
      }
    }
    if (message.kpi_actuals_rv_map) {
      const entries = Object.entries(message.kpi_actuals_rv_map);
      if (entries.length > 0) {
        obj.kpi_actuals_rv_map = {};
        entries.forEach(([k, v]) => {
          obj.kpi_actuals_rv_map[k] = v;
        });
      }
    }
    if (message.kpi_plan_rv_map) {
      const entries = Object.entries(message.kpi_plan_rv_map);
      if (entries.length > 0) {
        obj.kpi_plan_rv_map = {};
        entries.forEach(([k, v]) => {
          obj.kpi_plan_rv_map[k] = v;
        });
      }
    }
    if (message.is_struct_item !== false) {
      obj.is_struct_item = message.is_struct_item;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiCfgItem>, I>>(base?: I): StcsCompKpiCfgItem {
    return StcsCompKpiCfgItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiCfgItem>, I>>(object: I): StcsCompKpiCfgItem {
    const message = createBaseStcsCompKpiCfgItem();
    message.fpna_type = object.fpna_type ?? 0;
    message.sort_index = object.sort_index ?? 0;
    message.display_value_type = object.display_value_type ?? 0;
    message.kpi_pos_map = Object.entries(object.kpi_pos_map ?? {}).reduce<{ [key: string]: KpiPosItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = KpiPosItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.kpi_actuals_rv_map = Object.entries(object.kpi_actuals_rv_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.kpi_plan_rv_map = Object.entries(object.kpi_plan_rv_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.is_struct_item = object.is_struct_item ?? false;
    return message;
  },
};

function createBaseStcsCompKpiCfgItem_KpiPosMapEntry(): StcsCompKpiCfgItem_KpiPosMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiCfgItem_KpiPosMapEntry: MessageFns<StcsCompKpiCfgItem_KpiPosMapEntry> = {
  encode(message: StcsCompKpiCfgItem_KpiPosMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      KpiPosItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiCfgItem_KpiPosMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiCfgItem_KpiPosMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = KpiPosItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiCfgItem_KpiPosMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? KpiPosItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiCfgItem_KpiPosMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = KpiPosItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiCfgItem_KpiPosMapEntry>, I>>(
    base?: I,
  ): StcsCompKpiCfgItem_KpiPosMapEntry {
    return StcsCompKpiCfgItem_KpiPosMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiCfgItem_KpiPosMapEntry>, I>>(
    object: I,
  ): StcsCompKpiCfgItem_KpiPosMapEntry {
    const message = createBaseStcsCompKpiCfgItem_KpiPosMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? KpiPosItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiCfgItem_KpiActualsRvMapEntry(): StcsCompKpiCfgItem_KpiActualsRvMapEntry {
  return { key: "", value: 0 };
}

export const StcsCompKpiCfgItem_KpiActualsRvMapEntry: MessageFns<StcsCompKpiCfgItem_KpiActualsRvMapEntry> = {
  encode(message: StcsCompKpiCfgItem_KpiActualsRvMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiCfgItem_KpiActualsRvMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiCfgItem_KpiActualsRvMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiCfgItem_KpiActualsRvMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: StcsCompKpiCfgItem_KpiActualsRvMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiCfgItem_KpiActualsRvMapEntry>, I>>(
    base?: I,
  ): StcsCompKpiCfgItem_KpiActualsRvMapEntry {
    return StcsCompKpiCfgItem_KpiActualsRvMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiCfgItem_KpiActualsRvMapEntry>, I>>(
    object: I,
  ): StcsCompKpiCfgItem_KpiActualsRvMapEntry {
    const message = createBaseStcsCompKpiCfgItem_KpiActualsRvMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseStcsCompKpiCfgItem_KpiPlanRvMapEntry(): StcsCompKpiCfgItem_KpiPlanRvMapEntry {
  return { key: "", value: 0 };
}

export const StcsCompKpiCfgItem_KpiPlanRvMapEntry: MessageFns<StcsCompKpiCfgItem_KpiPlanRvMapEntry> = {
  encode(message: StcsCompKpiCfgItem_KpiPlanRvMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiCfgItem_KpiPlanRvMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiCfgItem_KpiPlanRvMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiCfgItem_KpiPlanRvMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: StcsCompKpiCfgItem_KpiPlanRvMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiCfgItem_KpiPlanRvMapEntry>, I>>(
    base?: I,
  ): StcsCompKpiCfgItem_KpiPlanRvMapEntry {
    return StcsCompKpiCfgItem_KpiPlanRvMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiCfgItem_KpiPlanRvMapEntry>, I>>(
    object: I,
  ): StcsCompKpiCfgItem_KpiPlanRvMapEntry {
    const message = createBaseStcsCompKpiCfgItem_KpiPlanRvMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseKpiPosItem(): KpiPosItem {
  return {
    pos_logic_type: 0,
    pos_index: 0,
    is_struct_item: false,
    display_value_type: 0,
    pos_activation_mode: undefined,
    manual_dec_input: undefined,
    formula_based: undefined,
  };
}

export const KpiPosItem: MessageFns<KpiPosItem> = {
  encode(message: KpiPosItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pos_logic_type !== 0) {
      writer.uint32(8).int32(message.pos_logic_type);
    }
    if (message.pos_index !== 0) {
      writer.uint32(24).uint32(message.pos_index);
    }
    if (message.is_struct_item !== false) {
      writer.uint32(32).bool(message.is_struct_item);
    }
    if (message.display_value_type !== 0) {
      writer.uint32(88).int32(message.display_value_type);
    }
    if (message.pos_activation_mode !== undefined) {
      writer.uint32(48).int32(message.pos_activation_mode);
    }
    if (message.manual_dec_input !== undefined) {
      PlanItemPosManualDecInput.encode(message.manual_dec_input, writer.uint32(842).fork()).join();
    }
    if (message.formula_based !== undefined) {
      KpiItemPosFormulaBased.encode(message.formula_based, writer.uint32(866).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KpiPosItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKpiPosItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.pos_logic_type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.pos_index = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.is_struct_item = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.display_value_type = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.pos_activation_mode = reader.int32() as any;
          continue;
        }
        case 105: {
          if (tag !== 842) {
            break;
          }

          message.manual_dec_input = PlanItemPosManualDecInput.decode(reader, reader.uint32());
          continue;
        }
        case 108: {
          if (tag !== 866) {
            break;
          }

          message.formula_based = KpiItemPosFormulaBased.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KpiPosItem {
    return {
      pos_logic_type: isSet(object.pos_logic_type) ? methodologyEnumFromJSON(object.pos_logic_type) : 0,
      pos_index: isSet(object.pos_index) ? globalThis.Number(object.pos_index) : 0,
      is_struct_item: isSet(object.is_struct_item) ? globalThis.Boolean(object.is_struct_item) : false,
      display_value_type: isSet(object.display_value_type)
        ? stcsDisplayValueTypeEnumFromJSON(object.display_value_type)
        : 0,
      pos_activation_mode: isSet(object.pos_activation_mode)
        ? kpiPosActivationModeEnumFromJSON(object.pos_activation_mode)
        : undefined,
      manual_dec_input: isSet(object.manual_dec_input)
        ? PlanItemPosManualDecInput.fromJSON(object.manual_dec_input)
        : undefined,
      formula_based: isSet(object.formula_based) ? KpiItemPosFormulaBased.fromJSON(object.formula_based) : undefined,
    };
  },

  toJSON(message: KpiPosItem): unknown {
    const obj: any = {};
    if (message.pos_logic_type !== 0) {
      obj.pos_logic_type = methodologyEnumToJSON(message.pos_logic_type);
    }
    if (message.pos_index !== 0) {
      obj.pos_index = Math.round(message.pos_index);
    }
    if (message.is_struct_item !== false) {
      obj.is_struct_item = message.is_struct_item;
    }
    if (message.display_value_type !== 0) {
      obj.display_value_type = stcsDisplayValueTypeEnumToJSON(message.display_value_type);
    }
    if (message.pos_activation_mode !== undefined) {
      obj.pos_activation_mode = kpiPosActivationModeEnumToJSON(message.pos_activation_mode);
    }
    if (message.manual_dec_input !== undefined) {
      obj.manual_dec_input = PlanItemPosManualDecInput.toJSON(message.manual_dec_input);
    }
    if (message.formula_based !== undefined) {
      obj.formula_based = KpiItemPosFormulaBased.toJSON(message.formula_based);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KpiPosItem>, I>>(base?: I): KpiPosItem {
    return KpiPosItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KpiPosItem>, I>>(object: I): KpiPosItem {
    const message = createBaseKpiPosItem();
    message.pos_logic_type = object.pos_logic_type ?? 0;
    message.pos_index = object.pos_index ?? 0;
    message.is_struct_item = object.is_struct_item ?? false;
    message.display_value_type = object.display_value_type ?? 0;
    message.pos_activation_mode = object.pos_activation_mode ?? undefined;
    message.manual_dec_input = (object.manual_dec_input !== undefined && object.manual_dec_input !== null)
      ? PlanItemPosManualDecInput.fromPartial(object.manual_dec_input)
      : undefined;
    message.formula_based = (object.formula_based !== undefined && object.formula_based !== null)
      ? KpiItemPosFormulaBased.fromPartial(object.formula_based)
      : undefined;
    return message;
  },
};

function createBaseKpiItemPosFormulaBased(): KpiItemPosFormulaBased {
  return {
    status: undefined,
    pos_input_base_amount: 0,
    formula_based_input_list: [],
    pos_actuals_rv_map: {},
    pos_plan_rv_map: {},
  };
}

export const KpiItemPosFormulaBased: MessageFns<KpiItemPosFormulaBased> = {
  encode(message: KpiItemPosFormulaBased, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== undefined) {
      StcsCalcItemStatus.encode(message.status, writer.uint32(10).fork()).join();
    }
    if (message.pos_input_base_amount !== 0) {
      writer.uint32(17).double(message.pos_input_base_amount);
    }
    for (const v of message.formula_based_input_list) {
      KpiFormulaBasedInput.encode(v!, writer.uint32(26).fork()).join();
    }
    Object.entries(message.pos_actuals_rv_map).forEach(([key, value]) => {
      KpiItemPosFormulaBased_PosActualsRvMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    Object.entries(message.pos_plan_rv_map).forEach(([key, value]) => {
      KpiItemPosFormulaBased_PosPlanRvMapEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KpiItemPosFormulaBased {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKpiItemPosFormulaBased();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status = StcsCalcItemStatus.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.pos_input_base_amount = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.formula_based_input_list.push(KpiFormulaBasedInput.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = KpiItemPosFormulaBased_PosActualsRvMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_actuals_rv_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = KpiItemPosFormulaBased_PosPlanRvMapEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.pos_plan_rv_map[entry5.key] = entry5.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KpiItemPosFormulaBased {
    return {
      status: isSet(object.status) ? StcsCalcItemStatus.fromJSON(object.status) : undefined,
      pos_input_base_amount: isSet(object.pos_input_base_amount) ? globalThis.Number(object.pos_input_base_amount) : 0,
      formula_based_input_list: globalThis.Array.isArray(object?.formula_based_input_list)
        ? object.formula_based_input_list.map((e: any) => KpiFormulaBasedInput.fromJSON(e))
        : [],
      pos_actuals_rv_map: isObject(object.pos_actuals_rv_map)
        ? Object.entries(object.pos_actuals_rv_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_plan_rv_map: isObject(object.pos_plan_rv_map)
        ? Object.entries(object.pos_plan_rv_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: KpiItemPosFormulaBased): unknown {
    const obj: any = {};
    if (message.status !== undefined) {
      obj.status = StcsCalcItemStatus.toJSON(message.status);
    }
    if (message.pos_input_base_amount !== 0) {
      obj.pos_input_base_amount = message.pos_input_base_amount;
    }
    if (message.formula_based_input_list?.length) {
      obj.formula_based_input_list = message.formula_based_input_list.map((e) => KpiFormulaBasedInput.toJSON(e));
    }
    if (message.pos_actuals_rv_map) {
      const entries = Object.entries(message.pos_actuals_rv_map);
      if (entries.length > 0) {
        obj.pos_actuals_rv_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_actuals_rv_map[k] = v;
        });
      }
    }
    if (message.pos_plan_rv_map) {
      const entries = Object.entries(message.pos_plan_rv_map);
      if (entries.length > 0) {
        obj.pos_plan_rv_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_plan_rv_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KpiItemPosFormulaBased>, I>>(base?: I): KpiItemPosFormulaBased {
    return KpiItemPosFormulaBased.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KpiItemPosFormulaBased>, I>>(object: I): KpiItemPosFormulaBased {
    const message = createBaseKpiItemPosFormulaBased();
    message.status = (object.status !== undefined && object.status !== null)
      ? StcsCalcItemStatus.fromPartial(object.status)
      : undefined;
    message.pos_input_base_amount = object.pos_input_base_amount ?? 0;
    message.formula_based_input_list =
      object.formula_based_input_list?.map((e) => KpiFormulaBasedInput.fromPartial(e)) || [];
    message.pos_actuals_rv_map = Object.entries(object.pos_actuals_rv_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_plan_rv_map = Object.entries(object.pos_plan_rv_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseKpiItemPosFormulaBased_PosActualsRvMapEntry(): KpiItemPosFormulaBased_PosActualsRvMapEntry {
  return { key: "", value: 0 };
}

export const KpiItemPosFormulaBased_PosActualsRvMapEntry: MessageFns<KpiItemPosFormulaBased_PosActualsRvMapEntry> = {
  encode(
    message: KpiItemPosFormulaBased_PosActualsRvMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KpiItemPosFormulaBased_PosActualsRvMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKpiItemPosFormulaBased_PosActualsRvMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KpiItemPosFormulaBased_PosActualsRvMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: KpiItemPosFormulaBased_PosActualsRvMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KpiItemPosFormulaBased_PosActualsRvMapEntry>, I>>(
    base?: I,
  ): KpiItemPosFormulaBased_PosActualsRvMapEntry {
    return KpiItemPosFormulaBased_PosActualsRvMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KpiItemPosFormulaBased_PosActualsRvMapEntry>, I>>(
    object: I,
  ): KpiItemPosFormulaBased_PosActualsRvMapEntry {
    const message = createBaseKpiItemPosFormulaBased_PosActualsRvMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseKpiItemPosFormulaBased_PosPlanRvMapEntry(): KpiItemPosFormulaBased_PosPlanRvMapEntry {
  return { key: "", value: 0 };
}

export const KpiItemPosFormulaBased_PosPlanRvMapEntry: MessageFns<KpiItemPosFormulaBased_PosPlanRvMapEntry> = {
  encode(message: KpiItemPosFormulaBased_PosPlanRvMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KpiItemPosFormulaBased_PosPlanRvMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKpiItemPosFormulaBased_PosPlanRvMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KpiItemPosFormulaBased_PosPlanRvMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: KpiItemPosFormulaBased_PosPlanRvMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KpiItemPosFormulaBased_PosPlanRvMapEntry>, I>>(
    base?: I,
  ): KpiItemPosFormulaBased_PosPlanRvMapEntry {
    return KpiItemPosFormulaBased_PosPlanRvMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KpiItemPosFormulaBased_PosPlanRvMapEntry>, I>>(
    object: I,
  ): KpiItemPosFormulaBased_PosPlanRvMapEntry {
    const message = createBaseKpiItemPosFormulaBased_PosPlanRvMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseKpiFormulaBasedInput(): KpiFormulaBasedInput {
  return { math_op: undefined, ref_fstmt: undefined, kpi_ref_item: undefined, ref_fstmt_agg: undefined };
}

export const KpiFormulaBasedInput: MessageFns<KpiFormulaBasedInput> = {
  encode(message: KpiFormulaBasedInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.math_op !== undefined) {
      writer.uint32(10).string(message.math_op);
    }
    if (message.ref_fstmt !== undefined) {
      FstmtRef.encode(message.ref_fstmt, writer.uint32(18).fork()).join();
    }
    if (message.kpi_ref_item !== undefined) {
      KpiFormulaBasedInput_KpiRefItem.encode(message.kpi_ref_item, writer.uint32(26).fork()).join();
    }
    if (message.ref_fstmt_agg !== undefined) {
      FstmtRefAgg.encode(message.ref_fstmt_agg, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KpiFormulaBasedInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKpiFormulaBasedInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.math_op = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_fstmt = FstmtRef.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.kpi_ref_item = KpiFormulaBasedInput_KpiRefItem.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ref_fstmt_agg = FstmtRefAgg.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KpiFormulaBasedInput {
    return {
      math_op: isSet(object.math_op) ? globalThis.String(object.math_op) : undefined,
      ref_fstmt: isSet(object.ref_fstmt) ? FstmtRef.fromJSON(object.ref_fstmt) : undefined,
      kpi_ref_item: isSet(object.kpi_ref_item)
        ? KpiFormulaBasedInput_KpiRefItem.fromJSON(object.kpi_ref_item)
        : undefined,
      ref_fstmt_agg: isSet(object.ref_fstmt_agg) ? FstmtRefAgg.fromJSON(object.ref_fstmt_agg) : undefined,
    };
  },

  toJSON(message: KpiFormulaBasedInput): unknown {
    const obj: any = {};
    if (message.math_op !== undefined) {
      obj.math_op = message.math_op;
    }
    if (message.ref_fstmt !== undefined) {
      obj.ref_fstmt = FstmtRef.toJSON(message.ref_fstmt);
    }
    if (message.kpi_ref_item !== undefined) {
      obj.kpi_ref_item = KpiFormulaBasedInput_KpiRefItem.toJSON(message.kpi_ref_item);
    }
    if (message.ref_fstmt_agg !== undefined) {
      obj.ref_fstmt_agg = FstmtRefAgg.toJSON(message.ref_fstmt_agg);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KpiFormulaBasedInput>, I>>(base?: I): KpiFormulaBasedInput {
    return KpiFormulaBasedInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KpiFormulaBasedInput>, I>>(object: I): KpiFormulaBasedInput {
    const message = createBaseKpiFormulaBasedInput();
    message.math_op = object.math_op ?? undefined;
    message.ref_fstmt = (object.ref_fstmt !== undefined && object.ref_fstmt !== null)
      ? FstmtRef.fromPartial(object.ref_fstmt)
      : undefined;
    message.kpi_ref_item = (object.kpi_ref_item !== undefined && object.kpi_ref_item !== null)
      ? KpiFormulaBasedInput_KpiRefItem.fromPartial(object.kpi_ref_item)
      : undefined;
    message.ref_fstmt_agg = (object.ref_fstmt_agg !== undefined && object.ref_fstmt_agg !== null)
      ? FstmtRefAgg.fromPartial(object.ref_fstmt_agg)
      : undefined;
    return message;
  },
};

function createBaseKpiFormulaBasedInput_KpiRefItem(): KpiFormulaBasedInput_KpiRefItem {
  return { kpi_type: 0, ref_id_kpi: "", offset_in_months: 0, fpna_period: undefined };
}

export const KpiFormulaBasedInput_KpiRefItem: MessageFns<KpiFormulaBasedInput_KpiRefItem> = {
  encode(message: KpiFormulaBasedInput_KpiRefItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kpi_type !== 0) {
      writer.uint32(8).int32(message.kpi_type);
    }
    if (message.ref_id_kpi !== "") {
      writer.uint32(18).string(message.ref_id_kpi);
    }
    if (message.offset_in_months !== 0) {
      writer.uint32(32).int32(message.offset_in_months);
    }
    if (message.fpna_period !== undefined) {
      StcsFpnaPeriod.encode(message.fpna_period, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KpiFormulaBasedInput_KpiRefItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKpiFormulaBasedInput_KpiRefItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kpi_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_kpi = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.offset_in_months = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fpna_period = StcsFpnaPeriod.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KpiFormulaBasedInput_KpiRefItem {
    return {
      kpi_type: isSet(object.kpi_type) ? stcsKpiEnumFromJSON(object.kpi_type) : 0,
      ref_id_kpi: isSet(object.ref_id_kpi) ? globalThis.String(object.ref_id_kpi) : "",
      offset_in_months: isSet(object.offset_in_months) ? globalThis.Number(object.offset_in_months) : 0,
      fpna_period: isSet(object.fpna_period) ? StcsFpnaPeriod.fromJSON(object.fpna_period) : undefined,
    };
  },

  toJSON(message: KpiFormulaBasedInput_KpiRefItem): unknown {
    const obj: any = {};
    if (message.kpi_type !== 0) {
      obj.kpi_type = stcsKpiEnumToJSON(message.kpi_type);
    }
    if (message.ref_id_kpi !== "") {
      obj.ref_id_kpi = message.ref_id_kpi;
    }
    if (message.offset_in_months !== 0) {
      obj.offset_in_months = Math.round(message.offset_in_months);
    }
    if (message.fpna_period !== undefined) {
      obj.fpna_period = StcsFpnaPeriod.toJSON(message.fpna_period);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KpiFormulaBasedInput_KpiRefItem>, I>>(base?: I): KpiFormulaBasedInput_KpiRefItem {
    return KpiFormulaBasedInput_KpiRefItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KpiFormulaBasedInput_KpiRefItem>, I>>(
    object: I,
  ): KpiFormulaBasedInput_KpiRefItem {
    const message = createBaseKpiFormulaBasedInput_KpiRefItem();
    message.kpi_type = object.kpi_type ?? 0;
    message.ref_id_kpi = object.ref_id_kpi ?? "";
    message.offset_in_months = object.offset_in_months ?? 0;
    message.fpna_period = (object.fpna_period !== undefined && object.fpna_period !== null)
      ? StcsFpnaPeriod.fromPartial(object.fpna_period)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
